<div class="_dialog-title justify-content-between" style="margin-bottom:0">
  <div class="text-xl">
    {{'OAT.share_order_title' | translate}}
  </div>
  <button mat-icon-button (click)="cancel()" class="dialog-close-button">
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>

<div class="_dialog-content">
  <block-ui>
    <div>
      @if (data.fromCreate) {
        <div class="alert alert-info text-center" style="font-size:13px; font-weight:600">{{'OAT.share_order_info' | translate}}</div>
      }
      @if (qrCodeUrl) {
        <div class="mt-4 text-center">
          <div class="mb-4">
            <div class="text-lg">{{ 'OAT.share_order_qr_info' | translate }}</div>
            @if (appService.urlParams.shortId) {
              <div class="text-accent pt-3" style="font-weight: 600">
                {{ 'order_short_code' | translate }}:&nbsp;
                <b>{{ appService.urlParams.shortId }}</b>
              </div>
            }
          </div>
          <div class="inline">
            <qrcode [qrdata]="qrCodeUrl" [width]="256" [level]="'M'"></qrcode>
          </div>
        </div>
      }
      @if (supportsSharing) {
        <div>
          <button mat-stroked-button color="accent" class="lg rounded btn-block mt-4" type="button" (click)="appService.passByShare()">
            {{'OAT.share_order_share_button' |translate}}
          </button>
        </div>
      }
      <button mat-stroked-button color="accent" class="lg rounded btn-block mt-4" type="button" (click)="appService.copyShareLink()">
        {{'OAT.share_order_link_button' |translate}}
      </button>
    </div>
  </block-ui>
</div>
